import styled from 'styled-components'
import Text from '../../UI/Text/Text'

export const StyledProjectLists = styled.div``

export const Headline = styled.div`
  margin-top: 50px;
  color: ${({ theme }) => theme.color.primary};
  font-family: 'bold';
  font-size: ${({ theme }) => theme.size.lg};
  padding-bottom: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.color.border};
`
export const NoLists = styled.div`
  text-align: center;
  margin-top: 20px;
`

export const Lists = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* gap: 15px; */
  /* margin-top: 25px; */
`

export const HeroOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  width: 30%;
  height: inherit;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-right: 15px solid ${({ theme }) => theme.color.primary};
`

export const TextWrapper = styled.div`
  padding: 50px;
`

export const HeroHeadline = styled(Text)`
  color: ${({ theme }) => theme.color.font.secondary};
  font-size: ${({ theme }) => theme.size.lg};
  text-transform: uppercase;
  font-family: 'bold';
`

export const HeroText = styled(Text)`
  margin-top: 10px;
  color: ${({ theme }) => theme.color.font.secondary};
`

export const SearchWrapper = styled.div`
  width: 70%;
  margin-left: 15%;
`
